import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import '../styles/globals.css';
import * as ga from '../lib/ga';
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { jsx as _jsx } from "react/jsx-runtime";

function App(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  var router = useRouter();
  useEffect(function () {
    var handleRouteChange = function handleRouteChange(url) {
      ga.pageview(url);
    }; // When the component is mounted, subscribe to router changes
    // and log those page views


    router.events.on('routeChangeComplete', handleRouteChange); // If the component is unmounted, unsubscribe
    // from the event with the `off` method

    return function () {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps));
}

export default App;